// utils
import { mapErrorsToModel } from '@kanrisha/utils/api';

export const getModels = async (page = 1, params = null) => {
  let sort = params.sort ? '&sort=' + params.sort : '';
  let size = params.size ? '&page[size]=' + params.size : '';
  let relation = params.relation ? '&relation=' + params.relation : '';
  let parent = params.parent ? '&parent=' + params.parent : '';
  let focus = params.focus ? '&focus=' + params.focus : '';
  let filter = {};
  for (let key in params.filter) {
    filter['filter[' + key + ']'] = params.filter[key];
  }
  for (let key in params.reject) {
    filter['reject[' + key + ']'] = params.reject[key];
  }

  return await window.axios
    .get(`/${params.resourceType}?page[number]=` + page + size + sort + relation + parent + focus, {
      params: filter,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getModel = async (id, resourceType) => {
  return await window.axios
    .get(`/${resourceType}/${id}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const pickModel = async (id, resourceType, relation, picked) => {
  return await window.axios
    .get(`/${resourceType}/${id}/pick/${relation}/${picked}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const focus = async (resourceType, relation) => {
  return await window.axios
    .get(`/${resourceType}/focus/${relation}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const storeModel = async (model, resourceType, params = {}) => {
  const method = model.data.id ? 'patch' : 'post';
  if (model.data.id === '' || model.data.id === null) {
    delete model.data.id;
  }
  let relation = params.relation ? '?relation=' + params.relation : '';
  let parent = params.parent ? '&parent=' + params.parent : '';
  let related = params.related ? '&related=' + params.related : '';

  return await window.axios
    .request({
      url: `/${resourceType}` + (model.data.id ? ('/' + model.data.id) : '') + relation + parent + related,
      method,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { data: model.data },
    })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
    })
    .catch((error) => {
      // Wenn Unprocessable Entity
      if (error.response.status === 422) {
        return mapErrorsToModel(error.response.data.errors);
      }
      return error.response.data;
    });
};

export const deleteModel = async (id, resourceType) => {
  return await window.axios
    .delete(`/${resourceType}/${id}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      if (response.status === 204) {
        return response.data;
      }
    });
};

export const attachModel = async (id, resourceType, relation, attachId) => {
  return await window.axios
    .get(`/${resourceType}/${id}/attach/${relation}/${attachId}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      if (response.status === 204) {
        return response.data;
      }
    });
};

export const detachModel = async (id, resourceType, relation, detachId) => {
  return await window.axios
    .get(`/${resourceType}/${id}/detach/${relation}/${detachId}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      if (response.status === 204) {
        return response.data;
      }
    });
};
